// @flow

import React from 'react';

import HideElement from '../HideElement';

type Props = {
  children: Node,
  footerSelector?: string,
};

const HideFooter = ({ children, footerSelector = '#footer' }: Props) => (
  <HideElement selector={footerSelector}>{children}</HideElement>
);

export default HideFooter;
